import { render, staticRenderFns } from "./EstablishmentPrivilegeForm.vue?vue&type=template&id=94c42ee4&scoped=true&"
import script from "./EstablishmentPrivilegeForm.vue?vue&type=script&lang=js&"
export * from "./EstablishmentPrivilegeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c42ee4",
  null
  
)

export default component.exports